"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Reward API for client FE
 * Reward API
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: cons.pompili@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueTypeEnum = void 0;
/**
 * ### The type of the issue:    * `STOCK` -    * `RETURN` -    * `WITHDRAW` -    * `REPLACEMENT` -    * `PAYMENT_PENDING` - Waiting for payment   * `ADDRESS_PENDING` - Waiting for address
 * @export
 * @enum {string}
 */
var IssueTypeEnum;
(function (IssueTypeEnum) {
    IssueTypeEnum["Stock"] = "STOCK";
    IssueTypeEnum["Return"] = "RETURN";
    IssueTypeEnum["Withdraw"] = "WITHDRAW";
    IssueTypeEnum["Replacement"] = "REPLACEMENT";
    IssueTypeEnum["PaymentPending"] = "PAYMENT_PENDING";
    IssueTypeEnum["AddressPending"] = "ADDRESS_PENDING";
    IssueTypeEnum["ApprovalPending"] = "APPROVAL_PENDING";
    IssueTypeEnum["BackofficeApprovalPending"] = "BACKOFFICE_APPROVAL_PENDING";
    IssueTypeEnum["PurchaseParameterPending"] = "PURCHASE_PARAMETER_PENDING";
    IssueTypeEnum["Other"] = "OTHER";
})(IssueTypeEnum = exports.IssueTypeEnum || (exports.IssueTypeEnum = {}));
